import { User } from './../../../../interfaces/interface-bakend/seguridad/users/user.interface';
import { Component, Input, OnInit } from '@angular/core';
import { Solicitud } from '../../../../interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import { SignoSedeService } from 'src/app/services/entidades/signo-sedes.service';
import { SignoSede } from 'src/app/interfaces/interface-bakend/entidades/signo-sede.interface';
import { UserEntreUser } from '@interfaces/interface-bakend/seguridad/users/user-entre-user.interface';

@Component({
  selector: 'app-ofertas-estado-detalle',
  templateUrl: './ofertas-estado-detalle.component.html',
  styleUrls: ['./ofertas-estado-detalle.component.scss']
})
export class OfertasEstadoDetalleComponent implements OnInit {

  imageUrl: string | ArrayBuffer = './assets/img/userDefault.png';

  @Input() solicitud: Solicitud;
  @Input() usuario: User;
  @Input() beneficiario: UserEntreUser;
  @Input() nombrePais: string;
  @Input() estadoFormulario: string;
  @Input() estadoDocumentacion: string;
  @Input() estadoPagoTotal: string;

  constructor(){
  }

  ngOnInit(): void {
  }

  copyToClipboard(text: string) {
    // Crear elemento temporal para copiar
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    
    // Mostrar feedback visual
    const emailElement = document.querySelector('.copy-email');
    emailElement.classList.add('copied');
    
    // Ocultar después de 1 segundos
    setTimeout(() => {
        emailElement.classList.remove('copied');
    }, 1000);
}

}
